import { Link } from "react-router-dom";
import { SocialLinks } from "../components/social/SocialLinks";
import { PageSeo } from "../components/seo/PageSeo";
import { getContentByLocale, getMediaByLocale } from "../content";
import { useI18n } from "../i18n";
import { ContactView } from "../views/home/ContactView";
import { HeroView } from "../views/home/HeroView";
import { MapView } from "../views/home/MapView";
import { StoryView } from "../views/home/StoryView";

export function HomePage() {
  const { locale } = useI18n();
  const content = getContentByLocale(locale);
  const mediaItems = getMediaByLocale(locale);
  const photoPreview = mediaItems.find(item => item.type === "fotos");
  const videoPreview = mediaItems.find(item => item.type === "videos");

  return (
    <>
      <PageSeo
        title={content.seo.defaultTitle}
        description={content.seo.defaultDescription}
      />

      <HeroView
        eyebrow={content.hero.eyebrow}
        title={content.hero.title}
        kicker={content.hero.kicker}
        description={content.hero.description}
        ctaLabel={content.hero.ctaLabel}
        ctaHref={content.hero.ctaHref}
        image={content.hero.image}
        imageAlt={content.hero.imageAlt}
      />

      <div className="home-scroll-content">
        <StoryView
          title={content.story.title}
          image={content.story.image}
          imageAlt={content.story.imageAlt}
          paragraphs={content.story.paragraphs}
        />

        <MapView
          title={content.map.title}
          region={content.map.region}
          image={content.map.image}
          imageAlt={content.map.imageAlt}
          locations={content.map.locations}
        />

        <section className="section media-highlight">
          <div className="media-highlight-header">
            <h2>{content.media.title}</h2>
            <p>{content.media.subtitle}</p>
          </div>
          <div className="media-highlight-grid">
            <article className="media-highlight-card">
              {photoPreview ? <img src={photoPreview.thumbnail} alt={photoPreview.title} /> : null}
              <div>
                <h3>{content.media.photosLabel}</h3>
                <Link className="hero-cta" to="/midia/fotos">
                  {content.media.openLabel}
                </Link>
              </div>
            </article>

            <article className="media-highlight-card">
              {videoPreview ? <img src={videoPreview.thumbnail} alt={videoPreview.title} /> : null}
              <div>
                <h3>{content.media.videosLabel}</h3>
                <Link className="hero-cta" to="/midia/videos">
                  {content.media.openLabel}
                </Link>
              </div>
            </article>
          </div>
        </section>

        <ContactView
          title={content.contact.title}
          description={content.contact.description}
          submitLabel={content.contact.submitLabel}
        />

        <SocialLinks items={content.social} />
      </div>
    </>
  );
}
